import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  header: {
    marginBottom: 20
  }
}))
export default useStyles
